<template>
  <div class="interaction-content-container surface">
    <div class="interaction-content custom-scrollbar">
      <v-window v-model="selectedTab">
        <v-window-item key="Interaction">
          <EcsEmail v-if="interaction.isEmail" :interaction-id="interaction.interactionId" />
          <EcsDirectCall v-else-if="interaction.isDirectCall" :interaction="interaction" />
          <EcsInteractionTabs v-else :interaction="interaction">
            <template #eachTabContent="{ element }">
              <EcsConversationMessages
                v-if="showMessages"
                :element-id="element.elementId"
                :interaction-id="interaction.interactionId"
                :is-sms="interaction.isSms"
              />
              <EcsCallWidget
                v-else-if="interaction.isTelephony"
                :interaction="interaction"
                :element-id="element.elementId"
              />
            </template>
          </EcsInteractionTabs>
        </v-window-item>
        <v-window-item key="Contact">
          <InteractionCrmContactSettings :interaction="interaction" />
        </v-window-item>
        <v-window-item key="History">
          <InteractionCrmHistory :contact-id="interaction.crm.contactId" />
        </v-window-item>
        <v-window-item key="Notes">
          <InteractionCrmNotes :contact-id="interaction.crm.contactId" />
        </v-window-item>
        <v-window-item key="VoiceMail">
          <InteractionVoiceMail :interaction="interaction" />
        </v-window-item>
        <v-window-item key="InteractionDetail">
          <InteractionCrmDetail :interaction="interaction" />
        </v-window-item>
      </v-window>
    </div>
  </div>
</template>
<script>
import EcsInteractionTabs from '@/components/ecs-interaction-tabs/EcsInteractionTabs';
import EcsConversationMessages from '@/components/ecs-conversation/ecs-conversation-messages/EcsConversationMessages';
import EcsCallWidget from '@/components/ecs-call-widget/EcsCallWidget';
import EcsEmail from '@/components/ecs-email/ecs-email-body/EcsEmail';
import InteractionCrmContactSettings from '@/components/ecs-interaction/InteractionCrmContactSettings';
import InteractionCrmHistory from '@/components/ecs-interaction/InteractionCrmHistory';
import InteractionCrmNotes from '@/components/ecs-interaction/InteractionCrmNotes';
import InteractionVoiceMail from '@/components/ecs-interaction/InteractionVoiceMail';
import InteractionCrmDetail from '@/components/ecs-interaction/InteractionCrmDetail';
import EcsDirectCall from '@/components/ecs-direct-call/EcsDirectCall.vue';

export default {
  name: 'InteractionContent',

  components: {
    EcsDirectCall,
    EcsInteractionTabs,
    EcsConversationMessages,
    EcsCallWidget,
    EcsEmail,
    InteractionVoiceMail,
    InteractionCrmContactSettings,
    InteractionCrmHistory,
    InteractionCrmNotes,
    InteractionCrmDetail
  },

  props: {
    interaction: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      selectedTab: 0
    };
  },

  computed: {
    showMessages() {
      return this.interaction.isChat || this.interaction.isSms;
    }
  },

  created() {
    this.$parent.$on('select-interaction-content-tab', tab => (this.selectedTab = tab || 0));
  },

  beforeDestroy() {
    this.$parent.$off('select-interaction-content-tab');
  }
};
</script>

<style scoped>
.interaction-content-container {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.interaction-content {
  height: 100%;
}

.interaction-content .v-window,
.interaction-content .v-window-item {
  height: 100%;
}
</style>
